import Slider from './components/Slider';
import TestimonialItem from './components/TestimonialItem';
import OurTeamItem from './components/OurTeamItem';
import HorizontalLine from './components/HorizontalLine';
import DiscountItem from './components/DiscountItem';
import BlogCard from './components/BlogCard';
import {Card, CardsList} from './components/cards';
import {BlogCardInBlog, BlogCardsList} from './components/blogCards';
import FormDialog from './components/FormDialog';
import ProgramOutline from './components/ProgramOutline';
import Gallery from './components/Gallery';
import TourShortInfo from './components/TourShortInfo';
import ImageWithDescription from './components/ImageWithDescription';
import AddressToMapComponent from './components/AddressToMapComponent';
import ContactInformation from './components/ContactInformation';
import CardsCarousel from './components/CardsCarousel';
import IconsWithText from './components/IconsWithText';
import SouvenirItem from './components/SouvenirItem';

export default {
    Slider,
    TestimonialItem,
    OurTeamItem,
    HorizontalLine,
    DiscountItem,
    Card,
    CardsList,
    BlogCard,
    BlogCardInBlog,
    BlogCardsList,
    FormDialog,
    ProgramOutline, 
    Gallery,
    TourShortInfo,
    ImageWithDescription,
    AddressToMapComponent,
    ContactInformation,
    CardsCarousel,
    IconsWithText,
    SouvenirItem
}